import React, { useEffect, useState } from 'react'
import { FeedShell } from './Poll'
import FadeIn from 'react-fade-in'
import NoContent from './NoContent'
export default function Feed({ posts, requestFeed }) {
    const [feedPosts, setFeedPosts] = useState(new Array())
    useEffect(() => { // TODO: Switch out for rtdb
        const newFeedPosts = new Array()
        if (!posts.length) {
            return setFeedPosts([<NoContent noBorder />])
        }
        for (let i = 0; i < posts.length; i++) {
            newFeedPosts.push(
                <FeedShell {...posts[i]} />
            )
            if (i + 1 === posts.length) {
                setFeedPosts(newFeedPosts)
            }
        }
    }, [posts])
    return (
        <FadeIn delay={100} className='feedContainer'>
            {feedPosts}
            {feedPosts?.length && requestFeed
                ? <div className='flex aic jcc'><button onClick={requestFeed} className='b2'>Load more</button></div>
                : null
            }
        </FadeIn>
    )
}
